module.exports = __webpack_public_path__ + "img/image_13.189f05b6.png";